import * as React from 'react'
import { DragSource } from 'react-dnd'
import { connect } from 'react-redux'
import type { SectionBlock } from 'types/content-editor'
import {
  insertSectionBlock,
  moveSectionBlock,
} from '@disco/state-management/actions/campaign-editor-actions'
import { SECTION_BLOCK } from './constants'
const blockSource = {
  beginDrag({ type, sectionIndex }) {
    return {
      type,
      sectionIndex,
    }
  },

  endDrag(props, monitor) {
    // seems to fix issues with drop in Firefox and Chrome if you drop element
    // outside the page(browser chrome, other windows etc)
    if (!monitor.didDrop()) return
    const { type, sectionIndex } = monitor.getItem()
    const { sectionIndex: targetSectionIndex } = monitor.getDropResult()

    if (typeof sectionIndex === 'number') {
      props.moveSectionBlock(sectionIndex, targetSectionIndex)
    } else {
      props.insertSectionBlock(targetSectionIndex, type)
    }
  },
}
export type WrapperProps = {
  type?: SectionBlock
  sectionIndex?: number
  connectDragSource: (...args: Array<any>) => any
  connectDragPreview: (...args: Array<any>) => any
  isDragging: boolean
  children: React.ReactElement<any>
}

class BlockDragWrapper extends React.Component<WrapperProps> {
  render() {
    const { connectDragSource, children } = this.props
    return connectDragSource(children)
  }
}

export const connectWrapper = (wrapper: any): any =>
  DragSource(SECTION_BLOCK, blockSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  }))(wrapper)
const dragSource = connectWrapper(BlockDragWrapper)
export default connect(null, {
  insertSectionBlock,
  moveSectionBlock,
})(dragSource) as any
